module.exports = {
    BASE_URL: 'http://testadmin.kxgwy.com',
};
